import gql from 'graphql-tag';

export default gql`
    query GetJobLogs($input: GetJobLogsInput) {
        getJobLogs(input: $input) {
            details {
                id
                jobLogIssueId
                jobLogIssue
                jobLogTypeId
                jobLogType
                jobId
                status
                startDate
                endDate
                estimatedDowntime
                jobStageId
                stage
                loadId
                notes
                locationLofa
                lofa
                amount
                rootCauseId
                rootCause
                correctiveAction
                dateCreated
                dateUpdated
                createdBy
                updatedBy
                wellName
                overallStage
                totalSandPumped
                duration
                allNotes
                fullNotes {
                    id
                    notes
                    dateCreated
                    createdBy
                }
            }
            isLastPage
        }
    }
`;
